<mat-expansion-panel [expanded]="true" *ngIf="clientStatisticsByMonth">
    <mat-expansion-panel-header>
        <mat-panel-title>
            {{ 'billing.CRM.charts.title' | translate }}
        </mat-panel-title>

        <mat-panel-description>
            {{ 'billing.CRM.charts.description' | translate }}
        </mat-panel-description>
    </mat-expansion-panel-header>
    <section class="chartsContainer">
        <app-crm-chart-by-month
            [statisticsByMonth]="clientStatisticsByMonth.statisticsByMonth"></app-crm-chart-by-month>
        <app-crm-chart-by-year [clientStatisticsByYear]="clientStatisticsByYear"></app-crm-chart-by-year>
    </section>
</mat-expansion-panel>